module.exports = __webpack_public_path__ + "img/fond-zebre-md.20620b4b.jpg";